import { Navigate, Outlet, useLocation } from "react-router-dom";

const SupporterRoute = () => {
  const location = useLocation();

  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  const isSupporter =
    Boolean(token) &&
    (role === "support" || role === "supporter" || role === "admin");

  if (!isSupporter) {
    return (
      <Navigate to="/panel/user" replace state={{ from: location.pathname }} />
    );
  }

  return <Outlet />;
};

export default SupporterRoute;
